// note: in alpine context we should provide the translated string
// to this function as the 'message' rather than parse language on
// the client side. This function just replaces placeholders.

import translations from '../../../lang/en.json'

export default (message, replace) => {
  let translation = message

  // TODO replace with real i18n solution
  if (/^countries\.[A-Z]{2}$/.test(message)) {
    const countryKey = message.replace('countries.', '')
    translation = translations[message] || countryKey
  }

  if (replace) {
    Object.entries(replace).forEach(([key, value]) => {
      translation = translation.replace(':' + key, value)
    })
  }

  return translation
}
